import React, { useState, Fragment, useEffect } from "react";
import { Form,
  Label,
  FormGroup, } from "reactstrap";
  import PropTypes from 'prop-types';
import { FormField, SelectFormField, CustomFormInput } from '../../../../../utils/FormFields';
import CircularProggess from '../../../../CircularProgress/CircularProgress';

function GroupsTab({
  account, changedAccount, showChanges,
}) {
  const editBankAccount = changedAccount.Groups[0];
  let compareBankAccount;
  account.Groups.map((b) => {
    if (parseInt(b.AccountGroupId, 10) === parseInt(editBankAccount.AccountGroupId, 10)) {
      compareBankAccount = b;
    }
    return {};
  });
  let color = 'black';
  if (showChanges) {
    if (compareBankAccount && editBankAccount.DeleteBankAccount) {
      color = 'red';
    } else if (compareBankAccount) {
      color = '#36a9e1';
    } else {
      color = 'green';
    }
  }

  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges
          ? (
            <React.Fragment>
              {editBankAccount.AccountGroupId > 0
                ? (
                  <React.Fragment>
                    {editBankAccount.DeleteGroup ? 'Delete Account Group' : 'Edit Account Group'}
                  </React.Fragment>
                )
                : 'New Account Group'}
            </React.Fragment>
          )
          : 'Actual Account Group'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {!editBankAccount.DeleteGroup
              && (
                <FormToShow
                  bankAccount={editBankAccount}
                  refBankAcc={compareBankAccount}
                />
              )}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareBankAccount
              && (
                <FormToShow
                  bankAccount={compareBankAccount}
                />
              )}
          </FormGroup>
        )}
    </Form>
  );
}

GroupsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};


export default GroupsTab;

const FormToShow = ({ bankAccount, refBankAcc }) => (
  <React.Fragment>
    {bankAccount.AccountGroupId > 0 && (
      <FormField
        name="BankAccountItemId"
        value={bankAccount.AccountGroupId}
        label="Id"
      />
    )}
    <FormField
      name="BankAccountName"
      value={bankAccount.AccountGroupName}
      label="Name"
      changedColor={refBankAcc && bankAccount.AccountGroupName !== refBankAcc.AccountGroupName}
    />
    <FormField
      name="BankAccountPersonalName"
      value={bankAccount.AccountGroupValue}
      label="Personal Name"
      changedColor={refBankAcc
        && bankAccount.AccountGroupValue !== refBankAcc.AccountGroupValue}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  bankAccount: PropTypes.object.isRequired,
  refBankAcc: PropTypes.object,
};

FormToShow.defaultProps = {
  refBankAcc: undefined,
};